import { getTimeRangeWithUnit } from '../../../checkout/components/ShoppingCartSummary/createDeliveryTimeText';
import { FilterData, PropertyData } from '../../../data/model';
import { FabricFacetFiltersTranslation } from '../../../localization/SiteTranslation';

export function filterOptionNameResolver(propertyData: PropertyData, translation: FabricFacetFiltersTranslation) {
  if (isPriceGroupFilter(propertyData.name)) {
    return `${translation.priceGroupShortLabel} ${propertyData.value}`;
  }

  if (isPreparingTimeFilter(propertyData.name)) {
    const split = propertyData.value.split('-');
    if (split.length !== 2) {
      return `${propertyData.displayName}`;
    }

    return getTimeRangeWithUnit(parseInt(split[0], 10), parseInt(split[1], 10), translation.shippingTimeText);
  }

  return propertyData.value;
}

export function filterDescriptionResolver(filterData: FilterData, translation: FabricFacetFiltersTranslation) {
  if (isPriceGroupFilter(filterData.name)) {
    return translation.priceGroupFilterDescription;
  }

  return null;
}

export function filterTitleResolver(filterData: FilterData, translation: FabricFacetFiltersTranslation) {
  if (isPriceGroupFilter(filterData.name)) {
    return translation.priceGroupFilterLabel;
  }

  if (isPreparingTimeFilter(filterData.name)) {
    return translation.leadTimeFilterLabel;
  }

  if (isFeatureFilter(filterData.name)) {
    return translation.fabricFeaturesFilterLabel;
  }

  return filterData.name;
}

function isFeatureFilter(filterName: string) {
  return filterName === 'FabricFeature';
}

function isPriceGroupFilter(filterName: string) {
  return filterName === 'PriceGroupFilter';
}

function isPreparingTimeFilter(filterName: string) {
  return filterName === 'PreparingTimeFilter';
}
